var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExerciseCardio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2415 4.56673C12.1582 4.56673 12.9082 3.81673 12.9082 2.90007C12.9082 1.9834 12.1582 1.2334 11.2415 1.2334C10.3249 1.2334 9.57487 1.9834 9.57487 2.90007C9.57487 3.81673 10.3249 4.56673 11.2415 4.56673ZM8.24154 16.1501L9.07487 12.4834L10.8249 14.1501V19.1501H12.4915V12.9001L10.7415 11.2334L11.2415 8.7334C12.3249 9.9834 13.9915 10.8167 15.8249 10.8167V9.15006C14.2415 9.15006 12.9082 8.31673 12.2415 7.15006L11.4082 5.81673C11.0749 5.31673 10.5749 4.9834 9.99154 4.9834C9.74154 4.9834 9.57487 5.06673 9.32487 5.06673L4.99154 6.90006V10.8167H6.6582V7.9834L8.1582 7.40007L6.82487 14.1501L2.74154 13.3167L2.4082 14.9834L8.24154 16.1501Z",
    fill: "#2F54EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExerciseCardio);
export default __webpack_public_path__ + "static/media/icon_exercise_cardio.31c2449705b2eacac6aeeb5287a639a6.svg";
export { ForwardRef as ReactComponent };